module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/icons/checked-ccf1b8c37474b623c95bfa01987b408a.svg";